<style scoped>
.checkin_information_data_statistics_all {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.checkin_information_data_statistics {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 0 40px;
  margin: 14px 0 10px 0;
}
.checkin_information_data_statistics_sing {
  display: flex;
  align-items: center;
  margin-right: 40px;
}
.checkin_information_data_statistics_title {
  color: rgba(19, 21, 35, 0.65);
  font-size: 16px;
}
.checkin_information_data_statistics_people {
  font-size: 30px;
  font-weight: bold;
  color: #131523;
  margin-left: 5px;
}
::v-deep .el-input__icon {
  line-height: 1.5rem;
}
.checkin_information_attendance_text {
  width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.checkin_information_data_content {
  width: 100%;
  padding: 0 0px 0 0px;
  box-sizing: border-box;
  flex: 1;
}
.checkin_information_data_raduis {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.checkin_information_data_content2 {
  width: 100%;
  flex: 1;
}
.depa_name {
  font-size: 20px;
  color: #131523;
  font-weight: bold;
  margin: 20px 0 0 46px;
}
</style>

<template>
  <div v-if="isAll" class="checkin_information_data_statistics_all">
    <div class="checkin_information_data_statistics">
      <div class="checkin_information_data_statistics_sing"
          v-for="(item, index) in statistics"
          :key="index"
      >
        <div class="checkin_information_data_statistics_title">
          {{ item.label }}
        </div>
        <div class="checkin_information_data_statistics_people">
          {{ item.value }}
        </div>
      </div>
    </div>
    <div  class="checkin_information_data_content"  id="addressChart" ref="addressChart"></div>
  </div>
  <div class="checkin_information_data_raduis" v-else>
    <div class="depa_name">{{ queryForm.deptName }}</div>
    <div
        id="raidsChart" ref="raidsChart"
        class="checkin_information_data_content2"
    ></div>
  </div>
</template>


<script>
import * as echarts from "echarts";
import { DashboardApi } from '@/api/nexus/dashboard';

export default {
  components: {},
  data() {
    return {
      queryForm: {},
      isAll: false,
      selectDepaName: "部门1",
      statistics: [
        { label: "正常通行：", value: 0 },
        { label: "非允许时段：", value: 0 },
      ],
      deptEcharts: null,
      pieDeptEcharts: null,
      echartsInterval: null,
    };
  },
  created() {

  },
  mounted() {
    this.intervalEcharts();
  },
  destroyed() {
    this.echartsInterval && clearInterval(this.echartsInterval);
    this.echartsInterval = null;
  },
  methods: {
    intervalEcharts() {
      this.echartsInterval = setInterval(async() => {
        if(this.deptEcharts){
          const {code,data} = await DashboardApi.queryDashboardBarOption(this.queryForm);
          this.statistics = [
            { label: "正常通行：", value: data?.totalNormalCount || 0},
            { label: "非允许时段：", value: data?.totalNotAllowedTimePeriodCount || 0 },
          ]
          let option = this.deptEcharts.getOption();
          option.series = data?.series || [];
          option.xAxis.data = data?.xaxis || [];
          option.dataZoom[0].end = (10 / (data?.xaxis?.length || 1)) * 100;
          this.deptEcharts.setOption(option);
        }
        if(this.pieDeptEcharts){
          const {code,data} = await DashboardApi.queryDashboardPieOption(this.queryForm);
          let option = this.pieDeptEcharts.getOption();
          option.series[0].data = data || [];
          this.pieDeptEcharts.setOption(option);
        }
      },30000)
    },
    init(query){
      this.isAll = !query.deptId;
      this.deptEcharts?.dispose();
      this.pieDeptEcharts?.dispose();
      this.deptEcharts = null;
      this.pieDeptEcharts = null;
      setTimeout(() => {
        this.queryForm = query;
        if(this.isAll){
          this.initEcharts();
        }else {
          this.initRadisEcharts();
        }
        this.$forceUpdate();
      },50)
    },
    async initEcharts() {
      const {code,data} = await DashboardApi.queryDashboardBarOption(this.queryForm);
      this.statistics = [
          { label: "正常通行：", value: data?.totalNormalCount || 0},
          { label: "非允许时段：", value: data?.totalNotAllowedTimePeriodCount || 0 },
      ]
      const option = {
        // 图例
        legend: {
          left: 30, // 让图例靠右 可以是数值 也可以是"%"
          to: 10,
          icon: 'circle'
        },
        // 提示框
        tooltip: {
          trigger: 'axis', // 触发类型 axis-坐标轴触发(主要在柱状图，折线图等会使用类目轴的图表中使用)
          // 坐标轴指示器配置项
          axisPointer: {
            type: 'shadow'
          }
        },
        // 绘图网格
        grid: {
          left: '3%', // 离容器左侧的距离
          right: '4%', // 离容器右侧的距离
          bottom: '3%', // 离容器下侧的距离
          containLabel: true // grid 区域是否包含坐标轴的刻度标签
        },
        xAxis: {
          data: data.xaxis || [],
          type: 'category', // 坐标轴类型为category-类目轴
          axisLabel: {
            //坐标轴刻度标签的相关设置
            show: true, //是否显示
            textStyle: {
              color: '#7E84A3',
              borderWidth: 0,
              fontSize: 14
            },
            interval: 0
          },
          axisTick: {
            show: false //是否显示
          }
        },
        yAxis: {
          type: 'value', // 坐标轴类型为数值轴
          minInterval: 1, // 最小间隔大小 因为此项目该数据不可能有小数 所以设置为1
          min: 0,
          max: (value) => {
            return value.max;
          },
          boundaryGap: [0, '10%']
        },
        series: data.series || [],
        dataZoom: [
          {
            type: 'inside', //鼠标可拖动
            start: 0, //滚动条开始位置
            end: 100, //滚动条结束位置
            handleSize: 2
          }
        ]
      };
      this.deptEcharts = echarts.init(this.$refs?.addressChart);
      this.deptEcharts.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.deptEcharts.resize();
      });
    },
    async initRadisEcharts() {
      const {code,data} = await DashboardApi.queryDashboardPieOption(this.queryForm);
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '0%',
          left: 'center'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10
            },
            label: {
              show: true,
              formatter: function (arg) {
                return arg.name + '-' + arg.value;
              }
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: data || []
          }
        ]
      };
      this.pieDeptEcharts = echarts.init(this.$refs?.raidsChart);
      this.pieDeptEcharts.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.pieDeptEcharts.resize();
      });
    },
  },

};
</script>